import stringHash from 'string-hash';
import { theme } from './theme';

const TAG_COLORS = [
  theme.customColors.primary,
  theme.customColors.secondary,
  theme.customColors.success,
  theme.customColors.error,
];
export const getTagColor = (tag: string) => TAG_COLORS[stringHash(tag) % TAG_COLORS.length];
